/**
 * created by tian ruo jun
 Editor
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from "antd";

export default class Editor extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            hideBtn: props.hideBtn
        }
    }

    show (){
        this.setState({hideBtn:false});
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            this.state.hideBtn ? "" :
            <div
                className={this.props.className}
                onClick={this.props.onClick}
            >
                {this.props.icon}
                {this.props.btnName}
            </div>
        )
    }

}